import { useDraftProvider } from '../../../Draft'

export function useRequestDraftProvider(prefix) {
  return useDraftProvider({ draftId: prefix })
}
